import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PreferencesDialogService} from "../../services/preferences-dialogs-service.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {ConfigurationCommons} from "../../../commons/services/configuration-commons.service";
import {EnvironmentType} from "../../../commons/types/environment.type";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {BringozToastService} from "../../../commons/services/bringoz-toast.service";

export class dispatchingConfigurationViewCtrl implements IController {

  preferences: any;
  parentGroup: string;

  private selectedTab: any;
  private tabs: any;

  public environment: EnvironmentType;

  /* @ngInject */
  constructor(private configurationCommons: ConfigurationCommons,
              private preferencesDialogService: PreferencesDialogService,
              private confirmDialogService: ConfirmDialogService,
              private commonsAlertsService: CommonsAlertsService,
              private splitService: SplitService,
              private commonsDialogService: CommonsDialogService,
              private bringozLoaderService: BringozLoaderService,
              private bringozToastService: BringozToastService,
              private $preferences,
              private $window,
              private moment,
              private apiConfig
  ) {

  }

  $onInit() {
    this.environment = this.apiConfig.env;
    this._getDispatchingSettings();
  }

  $onChanges(changes) {
    if (changes.preferences && !changes.preferences.isFirstChange()) {
      this.$onInit();
    }
  };

  onTabSelect(tab) {
    if (tab !== this.selectedTab) {
      this.selectedTab = tab;
    }
  }

  onUploadJSON(event) {
    this.commonsDialogService.uploadJSON(event)
      .then((validProperties) => {

        const parentGroup = _.get(validProperties, '[0].parentGroup');
        if (_.camelCase(parentGroup) === _.camelCase(this.parentGroup)) {

          this.confirmDialogService.confirm('Update Settings', 'Are you sure you want to update?', event)
            .then(() => {
              validProperties.forEach((p) => {
                p.siteId = this.splitService.getSiteId();
              })

              this._updateAllPreferences(validProperties);
            })
        } else {
          this.commonsAlertsService.updateJsonMismatchError();
        }
      })
  }

  onCopyJSON() {
    let allProperties = [];

    _.forOwn(this.preferences, (card: any, keyName: string) => {
      allProperties = allProperties.concat(card.list);
    })

    const text = JSON.stringify(allProperties);
    this.$window.navigator.clipboard.writeText(text).then((succ) => {
      const message = {
        body: 'TEXT_COPIED_TO_CLIPBOARD'
      };
      this.bringozToastService.success(message);
    });
  }

  onEdit(event, property, index) {
    this.preferencesDialogService.editPreferencesProperty(event, property)
      .then((updated) => {
        const updatedValue = updated[0];
        const group = _.camelCase(updatedValue.group);

        this.preferences[group].list[index] = updatedValue;
        this.commonsAlertsService.preferencesByNameSuccess('preferences.' + property.key + '.name');
      })
      .catch((error) => {
        if (error) {
          this.commonsAlertsService.preferencesError();
        }
      })
  }

  private _getDispatchingSettings() {
    this.tabs = this.configurationCommons.getPreferencesByTab(this.preferences);
  }

  private _updateAllPreferences(properties: any[]) {
    const propertiesToSend = [];
    properties.forEach((p) => {
      const property = angular.copy(p);

      if (property && _.isEqual(property.valueType, 'Date')) {
        property.value = JSON.stringify(this.moment(property.value).valueOf());
      }
      propertiesToSend.push(property);
    })

    this.bringozLoaderService.on();
    this.$preferences().$post(propertiesToSend)
      .then((updatedPreferences) => {
        this.preferences = this.configurationCommons.getPreferencesByGroup(updatedPreferences)[_.camelCase(this.parentGroup)];
        this.commonsAlertsService.preferencesUpdateSuccess();
      })
      .catch((error) => {
        this.commonsAlertsService.preferencesError();
        console.error('Error while updating preferences, @_updateAllPreferences: \n' + error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('dispatchingConfigurationView', {
    bindings: {
      preferences: '<',
      parentGroup: '<'
    },
    template: require('./dispatching-configuration-view.html').default,
    controller: dispatchingConfigurationViewCtrl
  });
